import { OnboardingProductType } from "@redotech/cockroachdb-codegen/congodb/onboarding-product-type";
import { createStringEnumSchema } from "@redotech/redo-onboarding-common/self-serve-onboarding-configuration";
import * as z from "zod";

const productTypeSchema = createStringEnumSchema(OnboardingProductType);

const assigneeSchema = z.object({
  email: z.string(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  department: z.string().optional(),
  name: z.string().optional(),
});

const lookupSchema = z.object({
  merchantId: z.string(),
  product: productTypeSchema,
});

const assigneeResultSchema = z.object({
  merchantId: z.string(),
  product: productTypeSchema,
  assignees: z.array(assigneeSchema),
});

export const getOnboardingAssignees = {
  name: "getOnboardingAssignees" as const,
  input: z.object({ lookups: z.array(lookupSchema) }),
  output: z.object({ results: z.array(assigneeResultSchema) }),
};

export type ProductType = z.infer<typeof productTypeSchema>;
export type Assignee = z.infer<typeof assigneeSchema>;
export type AssigneeLookup = z.infer<typeof lookupSchema>;
export type AssigneeResult = z.infer<typeof assigneeResultSchema>;
export type GetOnboardingAssigneesInput = z.infer<
  typeof getOnboardingAssignees.input
>;
export type GetOnboardingAssigneesOutput = z.infer<
  typeof getOnboardingAssignees.output
>;
